import { getCachedTranslation, setCachedTranslation } from './translationCache'

const GLM_API_KEY = process.env.VUE_APP_GLM_API_KEY || ''
const GLM_API_URL = 'https://open.bigmodel.cn/api/paas/v4/chat/completions'

function getStorage() {
  return typeof window !== 'undefined' ? window.localStorage : null
}

export async function translateReviewText(sourceText, targetLocale) {
  const cleanSource = String(sourceText || '').trim()
  if (!cleanSource || !targetLocale || targetLocale === 'en') return cleanSource

  const storage = getStorage()
  const cached = getCachedTranslation(storage, cleanSource, targetLocale)
  if (cached) return cached

  if (!GLM_API_KEY) {
    return cleanSource
  }

  const response = await fetch(GLM_API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${GLM_API_KEY}`
    },
    body: JSON.stringify({
      model: 'glm-4-flash',
      messages: [
        {
          role: 'system',
          content: `Translate the following text to ${targetLocale === 'zh-CN' ? 'Simplified Chinese' : 'English'}. Only return the translation, no explanation.`
        },
        { role: 'user', content: cleanSource }
      ]
    })
  })

  if (!response.ok) {
    return cleanSource
  }

  const data = await response.json()
  const translated = data?.choices?.[0]?.message?.content?.trim() || ''

  if (translated) {
    setCachedTranslation(storage, cleanSource, targetLocale, translated)
  }

  return translated || cleanSource
}
